import {OperationAlertDeliveryGroup} from "../../types/alert/operation-alert-delivery-group";

export const sortAlertGroups = (
    o1: OperationAlertDeliveryGroup,
    o2: OperationAlertDeliveryGroup,
    isDesc: boolean = true,
) => {
    if (
        !(o1.deliveryGroup.startTimeLimited && o2.deliveryGroup.startTimeLimited)
    ) {
        return 0;
    }

    let comparisonResult = 0;
    if (o1.deliveryGroup.startTimeLimited > o2.deliveryGroup.startTimeLimited) {
        comparisonResult = -1;
    } else if (
        o1.deliveryGroup.startTimeLimited < o2.deliveryGroup.startTimeLimited
    ) {
        comparisonResult = 1;
    }

    return isDesc ? comparisonResult : -comparisonResult;
};

export const sortDescAlertGroups = (
    o1: OperationAlertDeliveryGroup,
    o2: OperationAlertDeliveryGroup,
) => sortAlertGroups(o1, o2, true)

export const sortAscAlertGroups = (
    o1: OperationAlertDeliveryGroup,
    o2: OperationAlertDeliveryGroup,
) => sortAlertGroups(o1, o2, false)
